import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import { Route } from '../fixRoutes';
import AuthService from '../services/AuthService';
import { fetchBusinessInfo } from '../redux/business';

function ProtectedRoute(props: any) {

  const { component: Component, ...rest } = props;

  if (AuthService.loggedIn()) {
    props.fetchBusinessInfo();
    return <Route {...rest} render={(props: any) => <Component {...props} />} />;
  } else {
    props.redirect(props.location.pathname + props.location.search);
    return null;
  }
}

function mapStateToProps(state) {
  return {
    offer: state.offer,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    redirect: (redirectTo) => dispatch(push('/login?redirect=' + redirectTo)),
    fetchBusinessInfo: () => dispatch(fetchBusinessInfo()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProtectedRoute);
